<script lang="ts">
  import { useMachine } from "@xstate/svelte";
  import { purchaseModuleStore } from "../store/purchaseModule";
  import { setContext } from "svelte";

  let { machine = $bindable(undefined), children } = $props();
  if (machine == undefined) {
    machine = useMachine(purchaseModuleStore);
  }
  setContext("machineModule", machine);
</script>

{@render children?.({ machine, })}
